webpackJsonp([72],{

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1271);


/***/ }),

/***/ 1271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(174);

var _datetime2 = _interopRequireDefault(_datetime);

var _nl = __webpack_require__(779);

var _nl2 = _interopRequireDefault(_nl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('nl', _nl2.default);

/***/ })

},[1270]);


// WEBPACK FOOTER //
// app/datetime.nl-9ac8763fcf5e1306c3bc.js